import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import "../assets/CSS/Dashboard.css";
import axiosInstance from "../axiosConfig";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";

function RemarksApproval() {
  // const user = JSON.parse(localStorage.getItem("user")); // Get logged-in user data
  const [remarks, setRemarks] = useState([]); // All remarks
  const [filteredRemarks, setFilteredRemarks] = useState([]); // Filtered remarks
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
//   const [selectedRow, setSelectedRow] = useState(null); // Selected row for update
  const [filters, setFilters] = useState({
    searchQuery: "",
    fromDate: "",
    toDate: "",
  });


 const user = JSON.parse(localStorage.getItem("userData")); // make sure it's loaded
  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  // Fetch all remarks for the logged-in user
  const fetchRemarks = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/remarks-Notify");
      // const userRemarks = response.data.filter(
      //   (remark) => remark.SupervisorName === user?.Name // Filter by logged-in user's name
      // );
      // setRemarks(userRemarks);
      // setFilteredRemarks(userRemarks);
      setRemarks(response.data); // Set all remarks
      // setFilteredRemarks(userRemarks); // Initialize filtered remarks
    } catch (error) {
    //   console.error("Error fetching remarks:", error);
    //   alert("Failed to fetch remarks.");
    }
  }, []); // user?.Name

  

  useEffect(() => {
    fetchRemarks();
   
  }, [fetchRemarks,]);

  // Handle input changes for filters
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Apply filters (search and date range)
  useEffect(() => {
    const { searchQuery, fromDate, toDate } = filters;

    const filtered = remarks.filter((remark) => {
      const remarkDate = new Date(remark.RemarkDate);

      const matchesSearch =
        searchQuery === "" ||
        [
          remark.SupervisorName,
          remark.Department,
          remark.Remark,
          remark.Quantity.toString(),
        ]
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase());

      const matchesDate =
        (fromDate === "" || remarkDate >= new Date(fromDate)) &&
        (toDate === "" || remarkDate <= new Date(toDate));

      return matchesSearch && matchesDate;
    });

    setFilteredRemarks(filtered);
  }, [filters, remarks]);

  // 3) When “Approve” is clicked:
   const handleApprove = async (id) => {
    try {
      // Disable button immediately by setting remarks state; we'll flip row.Status to “Approving...”
      setRemarks((prev) =>
        prev.map((r) =>
          r.ID === id ? { ...r, Status: "Approving..." } : r
        )
      );

      await axiosInstance.patch(`/api/remarks/${id}/status`, {
        status: "Approved",
        ApprovedBy: user?.Name || "Unknown",
      });

      // On success, set that remark’s Status to “Approved”
      setRemarks((prev) =>
        prev.map((r) =>
          r.ID === id ? { ...r, Status: "Approved" } : r
        )
      );
      showAlert("Approved Successfully", "success");
    } catch (err) {
      console.error("Failed to approve remark:", err);
      // Optionally revert the “Approving...” to the previous value or show an alert
      fetchRemarks();
    }
  };


  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${
          type === "success" ? "Success!" : "Error!"
        }</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 2000);
  };


  // Columns for the DataTable
  const columns = [
    {
      name: "Remark Date", width:"150px",
      selector: (row) => row.RemarkDate,
      sortable: true,
    },
   {
      name: "Responsible Person",
      selector: (row) => (
        <span data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.Responsible_Person}>

        {row.Responsible_Person}
        </span>
      ),
    
      sortable: true,
    },
 {
      name: "Department", width:"150px",
      selector: (row) => (
      <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.Department}>
        {row.Department}
      </span>),       
      sortable: true,
    },
    {
      name: "LOT ID",
      selector: (row) => row.LOT_ID,
      sortable: true,
    },
    {
      name: "ProcessName",
      selector: (row) => row.ProcessName,
      sortable: true,
    },
    {
      name: "Parameters",
      selector: (row) => (
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.Parameters}>
        {row.Parameters}
      </span>),
      sortable: true,
    },
    {
      name: "DetailedIssue",width:"150px",
      selector: (row) => (
        <span data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.DetailedIssue}>

        {row.DetailedIssue}
        </span>
      ),
    //   row.Remark,
      sortable: false,
    }, 
     {
      name: "Created By",
      selector: (row) => (
        <span data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.CreatedBy}>

        {row.CreatedBy}
        </span>
      ),
    
      sortable: true,
    },
    {
      name: "Sent By",
      selector: (row) => (
        <span data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.SentBy}>

        {row.SentBy}
        </span>
      ),
    
      sortable: true,
    },
    {
      name: "Action",
      // In this column, if row.Status === "Approved", show green “Approved” text.
      // If row.Status === "Approving...", disable button and show “Approving…”.
      // Otherwise show a clickable “Approve” button.
      cell: (row) => {
        if (row.Status === "Approved") {
          return (
            <span style={{ color: "green", fontWeight: "bold" }}>
              Approved
            </span>
          );
        } else if (row.Status === "Approving...") {
          return (
            <button className="btn btn-sm btn-secondary" disabled>
              Approving…
            </button>
          );
        } else {
          return (
            <button
              className="btn btn-sm btn-primary"
              onClick={() => handleApprove(row.ID)}
            >
              Approve
            </button>
          );
        }
      },
      ignoreRowClick: true, // so clicking the button doesn’t select the row
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "fit-content" }}>
          <div className="container mt-0">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="mb-5">Remarks Approval</h3>
              {/* <div className="d-flex gap-2">
           
                </div> */}
            </div>

            {/* Filter Section */}
            <input
                  type="text"
                  name="searchQuery"
                  value={filters.searchQuery}
                  onChange={handleFilterChange}
                  className="form-control me-2 mb-3"
                  style={{ width: "auto" }}
                  placeholder="Search..."
                />

            {/* DataTable */}
            <DataTable
              columns={columns}
              data={filteredRemarks}
              pagination
            />
          </div>
        </main>
      </div>

     
    </div>
  );
}

export default RemarksApproval ;
